






















import { Vue, Component, Prop } from "@/shared/vuepack";
import type { PartnerBanner } from "@/shared/types";

@Component({})
export default class DeleteBannerModal extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;

  @Prop({ type: Object, required: false }) banner!: PartnerBanner;

  get isVisible () {
    return this.value;
  }
  set isVisible (val: boolean) {
    this.$emit("input", val);
  }

  onCancel () {
    this.isVisible = false;
    this.$emit("hide");
  }

  onConfirm () {
    this.isVisible = false;
    this.$emit("confirm", this.banner);
  }

  onHide () {
    this.$emit("hide");
  }
}
